import { CFormInput, CFormLabel } from '@coreui/react';
import React from 'react'
import CustomDatePickingFormat from './CustomDatePickingFormat';

const Topper = ({
    searchOptions = {}  ,
    selectDates = [],
    selectOptions = [],
}) => {
  return (
    <div className='d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap'>
        <div className='w-' style={{ width: searchOptions.width || "200px" }} >
            {searchOptions.label && <CFormLabel>{searchOptions.label || "Search Label"}</CFormLabel>}
            <CFormInput
            placeholder={searchOptions.placeholder || "Search"}
            onChange={searchOptions.onChange}
            value={searchOptions.value || ""}
            type={searchOptions.type || "text"}
            />
        </div>
        <div className='d-flex align-items-center gap-3 flex-wrap'>
        {
            selectDates && selectDates.map((datess,idx)=>{
                return(
                     <div className='' style={{ width: "max-content" }}>
                            {datess.label && <CFormLabel>{datess.label}</CFormLabel>}
                            <CustomDatePickingFormat
                                type="date"
                                color="primary"
                                // value={filterDataFacility.date || ""}
                                value={datess.value || ""}

                                aria-describedby="exampleFormControlInputHelpInline"
                                onChange={datess.onChange}
                            />
                        </div>
                )
            })
        }
        </div>
    </div>
  )
}

export default Topper